import React from "react";
import * as Sentry from "@sentry/react";
import { SentryAdapter, type Environment } from "@ir/core/logger/decorator";
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from "react-router";

interface ISentryConfig {
  dsn: string;
  environment: Environment;
  replaysSessionSampleRate: number;
  replaysOnErrorSampleRate: number;
}

export class SentryLogger extends SentryAdapter {
  constructor(options: ISentryConfig) {
    super();
    if (options.dsn) {
      Sentry.init({
        ...options,
        sendDefaultPii: true,
        enableLogs: true,
        integrations: [
          Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
            maskAllInputs: false,
          }),
          Sentry.reactRouterV7BrowserTracingIntegration({
            useEffect: React.useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
          }),
        ],
      });
    }
  }
}
